import {generateClient} from 'aws-amplify/api';
import {GraphQLQuery} from '@aws-amplify/api';

import {getPlatformControl} from './queries';
import {setPlatformControlState} from './mutations';
import {
    ControlState,
    PlatformControlRecord,
} from '../types';

const client = generateClient();

interface GetPlatformControlResponse {
    getPlatformControl: PlatformControlRecord | null;
}

interface SetPlatformControlStateResponse {
    setPlatformControlState: PlatformControlRecord | null;
}

/**
 * Read the live position of one control.
 *
 * Only controls that are actually wired have a backend entry; the API refuses an
 * unknown id rather than defaulting. Callers must handle a thrown error as
 * "position unknown" and never render a guess — this is a platform-wide switch.
 */
export const fetchControl = async (id: string): Promise<PlatformControlRecord | null> => {

    const response = await client.graphql<GraphQLQuery<GetPlatformControlResponse>>({
                                                                                        query: getPlatformControl,
                                                                                        variables: {id},
                                                                                    });

    return response.data?.getPlatformControl ?? null;
};

/**
 * Move a control.
 *
 * Authorization is enforced server-side: the mutation is gated on the `admin`
 * Cognito group, matching the sibling sensitive account mutations. The console's
 * own RBAC check only hides the affordance — it is not the security boundary.
 *
 * Idempotent server-side: setting the state it is already in is a no-op.
 */
export const updateControlState = async (
    id: string,
    state: ControlState,
): Promise<PlatformControlRecord | null> => {

    const response = await client.graphql<GraphQLQuery<SetPlatformControlStateResponse>>({
                                                                                             query: setPlatformControlState,
                                                                                             variables: {
                                                                                                 input: {
                                                                                                     id,
                                                                                                     state,
                                                                                                 },
                                                                                             },
                                                                                         });

    return response.data?.setPlatformControlState ?? null;
};
